export const 이용가이드메뉴목록 = [
  "기초정보",
  "상품",
  "거래처",
  "주문관리",
  "정보조회",
  "재고관리",
  "회계관리",
  "세금관리",
  "인사관리",
  "관리자",
  "환경설정",
] as const;

export type 이용가이드메뉴 = (typeof 이용가이드메뉴목록)[number];
